
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MarbleTextureEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const veins = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.15 / (layerIndex + 1);
            for (let i = 0; i < veins; i++) {
                ctx.lineWidth = (1 + this.pseudoRandom(i) * 5) * scale;
                ctx.beginPath();
                const startX = (this.pseudoRandom(i) - 0.5) * width * 3;
                ctx.moveTo(startX, -height * 2);
                for (let y = -height * 2; y <= height * 2; y += 50) {
                    const noise = Math.sin(y * 0.005 + curTime + i) * 100 * scale;
                    ctx.lineTo(startX + noise, y);
                }
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
